import { getSupabaseClient } from "@/integrations/supabase/client";

export class InvoiceServiceTab {
  static NUMBER_PREFIX = "0010000101";

  static async getNextInvoiceNumber(organizationId: string): Promise<string> {
    try {
      const supabase = getSupabaseClient();

      const { data: lastInvoice, error } = await supabase
        .from("tabs")
        .select("invoice_number")
        .eq("organization_id", organizationId)
        .like("invoice_number", `${this.NUMBER_PREFIX}%`)
        .order("invoice_number", { ascending: false })
        .limit(1)
        .maybeSingle();
      
      if (error) {
        console.error("Error getting last invoice number:", error);
        throw error;
      }

      let nextSequence = 1;
      if (lastInvoice?.invoice_number) {
        const takeLastTenDigits = lastInvoice.invoice_number.slice(-10);
        const lastSequence = parseInt(takeLastTenDigits, 10);
        nextSequence = lastSequence + 1;
      }

      const fillWithZero = nextSequence.toString().padStart(10, "0");
      return `${this.NUMBER_PREFIX}${fillWithZero}`;
    } catch (error) {
      console.error("Error generating invoice number:", error);
      throw error;
    }
  }

  static async assignInvoiceNumberToTab(
    tabId: string,
    organizationId: string
  ): Promise<string> {
    try {
      const invoiceNumber = await this.getNextInvoiceNumber(organizationId);
      const supabase = getSupabaseClient();

      const { error } = await supabase
        .from("tabs")
        .update({ invoice_number: invoiceNumber })
        .eq("id", tabId);

      if (error) {
        console.error("Error assigning invoice number to tab:", error);
        throw error;
      }

      return invoiceNumber;
    } catch (error) {
      console.error("Error assigning invoice number:", error);
      throw error;
    }
  }
}
